import * as e from "react";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.5/node_modules/@heroicons/react/24/outline/esm/ArrowPathIcon.js
function r({ title: t, titleId: n, ...r }, i) {
	return /* @__PURE__ */ e.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), t ? /* @__PURE__ */ e.createElement("title", { id: n }, t) : null, /* @__PURE__ */ e.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
	}));
}
var i = /* @__PURE__ */ e.forwardRef(r);
//#endregion
//#region ../../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.5/node_modules/@heroicons/react/24/outline/esm/CloudArrowUpIcon.js
function a({ title: t, titleId: n, ...r }, i) {
	return /* @__PURE__ */ e.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), t ? /* @__PURE__ */ e.createElement("title", { id: n }, t) : null, /* @__PURE__ */ e.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"
	}));
}
var o = /* @__PURE__ */ e.forwardRef(a);
//#endregion
//#region ../../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.5/node_modules/@heroicons/react/24/outline/esm/FingerPrintIcon.js
function s({ title: t, titleId: n, ...r }, i) {
	return /* @__PURE__ */ e.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), t ? /* @__PURE__ */ e.createElement("title", { id: n }, t) : null, /* @__PURE__ */ e.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M7.864 4.243A7.5 7.5 0 0 1 19.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 0 0 4.5 10.5a7.464 7.464 0 0 1-1.15 3.993m1.989 3.559A11.209 11.209 0 0 0 8.25 10.5a3.75 3.75 0 1 1 7.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596a18.666 18.666 0 0 1-2.485 5.33"
	}));
}
var c = /* @__PURE__ */ e.forwardRef(s);
//#endregion
//#region ../../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.5/node_modules/@heroicons/react/24/outline/esm/LockClosedIcon.js
function l({ title: t, titleId: n, ...r }, i) {
	return /* @__PURE__ */ e.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), t ? /* @__PURE__ */ e.createElement("title", { id: n }, t) : null, /* @__PURE__ */ e.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
	}));
}
//#endregion
//#region src/components/FeatureSelection.tsx
var u = [
	{
		name: "Push to deploy",
		description: "Morbi viverra dui mi arcu sed. Tellus semper adipiscing suspendisse semper morbi. Odio urna massa nunc massa.",
		icon: o
	},
	{
		name: "SSL certificates",
		description: "Sit quis amet rutrum tellus ullamcorper ultricies libero dolor eget. Sem sodales gravida quam turpis enim lacus amet.",
		icon: /* @__PURE__ */ e.forwardRef(l)
	},
	{
		name: "Simple queues",
		description: "Quisque est vel vulputate cursus. Risus proin diam nunc commodo. Lobortis auctor congue commodo diam neque.",
		icon: i
	},
	{
		name: "Advanced security",
		description: "Arcu egestas dolor vel iaculis in ipsum mauris. Tincidunt mattis aliquet hac quis. Id hac maecenas ac donec pharetra eget.",
		icon: c
	}
], d = () => /* @__PURE__ */ t("div", {
	className: "dec-root",
	children: /* @__PURE__ */ t("div", {
		className: "dec:bg-white dec:py-24 sm:dec:py-32",
		children: /* @__PURE__ */ n("div", {
			className: "dec:mx-auto dec:max-w-7xl dec:px-6 lg:dec:px-8",
			children: [/* @__PURE__ */ n("div", {
				className: "dec:mx-auto dec:max-w-2xl lg:dec:text-center",
				children: [
					/* @__PURE__ */ t("h2", {
						className: "dec:text-base/7 dec:font-semibold dec:text-indigo-600",
						children: "Deploy faster"
					}),
					/* @__PURE__ */ t("p", {
						className: "dec:mt-2 dec:text-4xl dec:font-semibold dec:tracking-tight dec:text-pretty dec:text-gray-900 sm:dec:text-5xl lg:dec:text-balance",
						children: "Everything you need to deploy your app"
					}),
					/* @__PURE__ */ t("p", {
						className: "dec:mt-6 dec:text-lg/8 dec:text-gray-700",
						children: "Quis tellus eget adipiscing convallis sit sit eget aliquet quis. Suspendisse eget egestas a elementum pulvinar et feugiat blandit at. In mi viverra elit nunc."
					})
				]
			}), /* @__PURE__ */ t("div", {
				className: "dec:mx-auto dec:mt-16 dec:max-w-2xl sm:dec:mt-20 lg:dec:mt-24 lg:dec:max-w-4xl",
				children: /* @__PURE__ */ t("dl", {
					className: "dec:grid dec:max-w-xl dec:grid-cols-1 dec:gap-x-8 dec:gap-y-10 lg:dec:max-w-none lg:dec:grid-cols-2 lg:dec:gap-y-16",
					children: u.map((e) => /* @__PURE__ */ n("div", {
						className: "dec:relative dec:pl-16",
						children: [/* @__PURE__ */ n("dt", {
							className: "dec:text-base/7 dec:font-semibold dec:text-gray-900",
							children: [/* @__PURE__ */ t("div", {
								className: "dec:absolute dec:top-0 dec:left-0 dec:flex dec:size-10 dec:items-center dec:justify-center dec:rounded-lg dec:bg-indigo-600",
								children: /* @__PURE__ */ t(e.icon, {
									"aria-hidden": "true",
									className: "dec:size-6 dec:text-white"
								})
							}), e.name]
						}), /* @__PURE__ */ t("dd", {
							className: "dec:mt-2 dec:text-base/7 dec:text-gray-600",
							children: e.description
						})]
					}, e.name))
				})
			})]
		})
	})
});
//#endregion
export { d as FeatureSelection };

//# sourceMappingURL=index.js.map